import { all_routes } from "../../../feature-module/router/all_routes";
const routes = all_routes;

export const SidebarData = [
  {
    label: "MAIN",
    submenuOpen: true,
    showSubRoute: false,
    submenuHdr: "Main",
    allowedRoles: ["superadmin", "centeradmin"],
    submenuItems: [
      {
        label: "Dashboard",
        icon: "ti ti-layout-dashboard",
        submenu: false,
        showSubRoute: false,
        link: routes.adminDashboard,
        allowedRoles: ["superadmin", "centeradmin"],
      },
    ],
  },
  {
    label: "Peoples",
    submenuOpen: true,
    showSubRoute: false,
    submenuHdr: "Peoples",
    allowedRoles: ["superadmin", "centeradmin"],
    submenuItems: [
      {
        label: "Centers",
        icon: "ti ti-building",
        submenu: false,
        showSubRoute: false,
        link: routes.centerList,
        allowedRoles: ["superadmin"],
      },
      {
        label: "Students",
        icon: "ti ti-school",
        submenu: false,
        showSubRoute: false,
        link: routes.studentList,
        allowedRoles: ["superadmin", "centeradmin"],
      },
      {
        label: "Student Transfers",
        icon: "ti ti-exchange",
        submenu: false,
        showSubRoute: false,
        link: routes.studentTransfers,
        allowedRoles: ["superadmin", "centeradmin"],
      },
    ],
  },

  {
    label: "Attendance",
    icon: "ti ti-calendar-share",
    submenu: true,
    showSubRoute: false,
    allowedRoles: ["superadmin", "centeradmin"],
    submenuItems: [
      {
        label: "Student Attendance",
        link: routes.studentAttendance,
        icon: "ti ti-calendar-check",
        allowedRoles: ["superadmin", "centeradmin"],
      },
    ],
  },
  {
    label: "Assessment",
    icon: "ti ti-book",
    submenu: true,
    showSubRoute: false,
    allowedRoles: ["superadmin", "centeradmin"],
    submenuItems: [
      {
        label: "Assign Marks",
        link: routes.assignMarks,
        icon: "ti ti-book",
        allowedRoles: ["superadmin", "centeradmin"],
      },
    ],
  },
  {
    label: "Promotion",

    submenu: false,
    showSubRoute: false,
    submenuItems: [
      {
        label: "Student Promotion",
        icon: "ti ti-arrow-up",
        link: routes.studentPromotion,
        allowedRoles: ["superadmin", "centeradmin"],
      },
    ],
  },
  {
    label: "Fee Collection",
    icon: "ti ti-report-money",
    submenu: true,
    showSubRoute: false,
    allowedRoles: ["superadmin", "centeradmin"],
    submenuItems: [
      {
        label: "Collect Fees",
        icon: "ti ti-report-money",
        link: routes.collectFees,
        allowedRoles: ["superadmin", "centeradmin"],
      },
      // {
      //   label: "Offline Fee Payments",
      //   icon: "ti ti-cash",
      //   link: routes.studentOfflinePayments,
      //   allowedRoles: ["superadmin", "centeradmin"],
      // },
      {
        label: "Fee Configuration",
        icon: "ti ti-settings",
        submenu: true,
        showSubRoute: false,
        allowedRoles: ["superadmin"],
        submenuItems: [
          {
            label: "Course Level Fee",
            icon: "ti ti-money",
            link: routes.feesConfiguration,
            allowedRoles: ["superadmin"],
          },
          {
            label: "Course Registration Fee",
            icon: "ti ti-money",
            link: routes.courseRegistrationFee,
            allowedRoles: ["superadmin"],
          },
        ],
      },
      // {
      //   label: "Fee Types",
      //   icon: "ti ti-list-details",
      //   link: routes.feeTypes,
      //   allowedRoles: [],
      // },
    ],
  },
  {
    label: "Claims",
    icon: "ti ti-exchange",
    submenu: true,
    showSubRoute: false,
    allowedRoles: ["superadmin", "centeradmin"],
    submenuItems: [
      // {
      //   label: "Fee Share",
      //   icon: "ti ti-list",
      //   submenu: true,
      //   showSubRoute: true,
      //   allowedRoles: ["superadmin"],
      //   submenuItems: [
      //     {
      //       label: "Course Fee Share",
      //       link: routes.courseFeeShareList,
      //       allowedRoles: ["superadmin"],
      //     },
      //     {
      //       label: "Registration Fee Share",
      //       link: routes.registrationFeeShareList,
      //       allowedRoles: ["superadmin"],
      //     },
      //   ],
      // },
      {
        label: "Claims",
        link: routes.payShareList,
        icon: "ti ti-exchange",
        allowedRoles: ["centeradmin", "superadmin"],
      },
    ],
  },
  {
    label: "Library",
    icon: "ti ti-books",
    submenu: true,
    showSubRoute: false,
    allowedRoles: ["superadmin", "centeradmin"],
    submenuItems: [
      {
        label: "Book Requests",
        icon: "ti ti-book-upload",
        link: routes.bookRequestList,
        allowedRoles: ["superadmin", "centeradmin"],
      },
    ],
  },
  {
    label: "Configuration",
    icon: "ti ti-settings",
    submenu: true,
    showSubRoute: false,
    allowedRoles: ["superadmin", "centeradmin"],
    submenuItems: [
      {
        label: "Session Management",
        link: routes.sessionList,
        icon: "ti ti-clock",
        allowedRoles: ["superadmin"],
      },
      {
        label: "Course Management",
        link: routes.courseList,
        icon: "ti ti-book",
        allowedRoles: ["superadmin"],
      },
      {
        label: "Batch Timing",
        link: routes.batchTimingList,
        icon: "ti ti-clock",
        allowedRoles: ["superadmin", "centeradmin"],
      },
    ],
  },
  {
    label: "Inventory",
    icon: "ti ti-box",
    submenu: true,
    showSubRoute: false,
    allowedRoles: ["superadmin", "centeradmin"],
    submenuItems: [
      {
        label: "Starter Kit Stock",
        link: routes.starterKitInventory,
        icon: "ti ti-package",
        allowedRoles: ["superadmin"],
      },
      {
        label: "Kit Distribution",
        link: routes.starterKitTransactions,
        icon: "ti ti-exchange",
        allowedRoles: ["superadmin", "centeradmin"],
      },
    ],
  },
  {
    label: "Settings",
    icon: "ti ti-settings",
    submenu: true,
    showSubRoute: false,
    allowedRoles: ["superadmin", "centeradmin"],
    submenuItems: [
      {
        label: "Site Settings",
        link: routes.settingList,
        icon: "ti ti-settings",
        allowedRoles: ["superadmin"],
      },
      {
        label: "Notifications",
        link: routes.notificationList,
        icon: "ti ti-bell",
        allowedRoles: ["superadmin", "centeradmin"],
      },
    ],
  },
];
